import Swiper, { Navigation, Pagination, A11y, Thumbs } from 'swiper';

// Initialize Swipers with thumbs
document.querySelectorAll('[data-swiper-thumbs]').forEach((thumbsEl, idx) => {
    const swiperEl = document.querySelectorAll('[data-swiper-thumbSwiper]')[idx];
    if (!swiperEl) return;

    const thumbSwiper = new Swiper(thumbsEl, {
        spaceBetween: 11,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
    });

    new Swiper(swiperEl, {
        modules: [Navigation, Pagination, A11y, Thumbs],
        spaceBetween: 11,
        navigation: {
            nextEl: swiperEl.querySelector(".swiper-button-next"),
            prevEl: swiperEl.querySelector(".swiper-button-prev"),
        },
        pagination: {
            el: swiperEl.querySelector(".swiper-pagination"),
        },
        a11y: {
            enabled: true,
            slideLabelMessage: 'Bild {{index}} von {{slidesLength}}',
            firstSlideMessage: 'Erster Slide',
            lastSlideMessage: 'Letzter Slide',
            nextSlideMessage: 'Nächster Slide',
            paginationBulletMessage: 'Gehe zum Slide {{index}}',
            prevSlideMessage: 'Zum vorherigen Slide',
            nextSlideMessage: 'Zum nächsten Slide',
        },
        thumbs: {
            swiper: thumbSwiper,
        },
    });
});

// Initialize Swipers without thumbs
document.querySelectorAll('[data-swiper]').forEach((swiperEl) => {
    // Skip if this swiper already has a thumbs swiper initialized
    if (swiperEl.hasAttribute('data-swiper-initialized')) return;
    swiperEl.setAttribute('data-swiper-initialized', 'true');

    new Swiper(swiperEl, {
        modules: [Navigation, Pagination, A11y],
        spaceBetween: 11,
        navigation: {
            nextEl: swiperEl.querySelector(".swiper-button-next"),
            prevEl: swiperEl.querySelector(".swiper-button-prev"),
        },
        pagination: {
            el: swiperEl.querySelector(".swiper-pagination"),
        },
        a11y: {
            enabled: true,
            slideLabelMessage: 'Bild {{index}} von {{slidesLength}}',
            firstSlideMessage: 'Erster Slide',
            lastSlideMessage: 'Letzter Slide',
            nextSlideMessage: 'Nächster Slide',
            paginationBulletMessage: 'Gehe zum Slide {{index}}',
            prevSlideMessage: 'Zum vorherigen Slide',
            nextSlideMessage: 'Zum nächsten Slide',
        },
    });
});
